import { Construction } from '@mui/icons-material'
import { LkmAppealsList } from '../lkmAppealsList'
import {
  useGetAppealsListQuery,
  useSubmitOrderFormMutation,
} from 'feature/lkmAppeals/redux/LkmAppeals.api'
import styles from './LkmAppeals.module.scss'
import { SyntheticEvent, useEffect, useState } from 'react'
import {
  IAppeal,
  TAppealModalInfo,
  TAppealStatus,
} from 'feature/lkmAppeals/types'
import { LkmAppealsTabs } from '../lkmAppealsTabs'
import { LkmAppealOfferModal } from 'feature/lkmAppeals/components/LkmAppealOfferModal'
import { LkmAppealsStatistics } from '../lkmAppealsStatistics'
import { useSearchParams } from 'react-router-dom'

export const LkmAppeals = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [selectedStatus, setSelectedStatus] = useState<TAppealStatus>(() => {
    const statusFromUrl = searchParams.get('status')
    if (statusFromUrl === 'in_progress' || statusFromUrl === 'completed') {
      return statusFromUrl as TAppealStatus
    }
    return 'new'
  })
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [open, setOpen] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState<TAppealModalInfo | null>(
    null,
  )

  const [submitOrderForm, { isLoading }] = useSubmitOrderFormMutation()
  const { data, isFetching } = useGetAppealsListQuery({
    status: selectedStatus,
    page: currentPage,
  })

  const appeals = data?.result.claims || []
  const totalCount = data?.result.count || 0
  const hasMore = appeals.length < totalCount

  useEffect(() => {
    const statusFromUrl = searchParams.get('status')

    if (
      !statusFromUrl ||
      !['new', 'in_progress', 'completed'].includes(statusFromUrl)
    ) {
      // Только один раз — если параметра нет или он невалидный
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev)
        newParams.set('status', 'new')
        return newParams
      })
    }
  }, [])

  const loadMore = () => {
    if (!isFetching && hasMore) {
      setCurrentPage(prev => prev + 1)
    }
  }

  const handleCloseOfferModal = () => {
    setOpen(false)
    setSelectedOrder(null)
  }

  const handleOpenOfferModal = (item: IAppeal) => {
    setOpen(true)
    setSelectedOrder({
      number: item.id,
      name: item.name,
    })
  }

  const changeStatus = (_: SyntheticEvent, newValue: TAppealStatus) => {
    setSelectedStatus(newValue)
    setCurrentPage(1)

    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev)
      newParams.set('status', newValue)
      return newParams
    })
  }

  return (
    <div className={styles.appealsList}>
      <div className={styles.appealsList__title}>
        <Construction color='primary' />

        <h1>Мои монтажи</h1>
      </div>

      <LkmAppealsTabs changeStatus={changeStatus} value={selectedStatus} />

      {selectedStatus === 'completed' && <LkmAppealsStatistics />}

      <LkmAppealsList
        appealsList={appeals}
        setNextPage={loadMore}
        totalCount={totalCount}
        isFetching={isFetching}
        currentPage={currentPage}
        onOpen={handleOpenOfferModal}
      />

      <LkmAppealOfferModal
        open={open}
        onClose={handleCloseOfferModal}
        description={{
          id: selectedOrder?.number ?? 0,
          name: selectedOrder?.name,
        }}
        submitOrderForm={submitOrderForm}
        isLoading={isLoading}
      />
    </div>
  )
}
